export enum TipoCorrecaoTransacao {
  NENHUMA = 0,
  SUBSTITUIR = 1,
  EXCLUIR = 2,
}
